import { render, staticRenderFns } from "./InsurancesInfo.vue?vue&type=template&id=694aeb2e&"
import script from "./InsurancesInfo.vue?vue&type=script&lang=js&"
export * from "./InsurancesInfo.vue?vue&type=script&lang=js&"
import style0 from "./InsurancesInfo.vue?vue&type=style&index=0&id=694aeb2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports